"use client";

import { healthService } from "@/_services/health";
import { useInitializeAuth } from "@/_hooks/auth/useInitializeAuth";
import useSWR from "swr";
import { initMixpanel } from "../mixpanel/mixpanelClient";
import { useEffect } from "react";
import { useOnboardingNewbie } from "@/_hooks/useOnboardingNewbie";

/**
 * - This component is used to handle preflight requests from the client.
 * - Check if the server is still alive.
 * - If the server is not alive, show a toast error.
 * @returns null
 */
export const Preflight = () => {
  useInitializeAuth();
  useOnboardingNewbie();

  useEffect(() => {
    initMixpanel();
  }, []);

  useSWR("/health", healthService.getHealth, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    refreshInterval: 60000,
  });

  return null;
};
